import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as MenuExpandIcon } from '../assets/icons/menu-expand.svg';

export default function TeamTimeCardToolbar({
  panelCollapsed,
  onTogglePanelCollapsed,
}) {
  return (
    <div className="team-timecard-toolbar">
      {
        panelCollapsed && (
          <button
            type="button"
            className="team-members-icon-button"
            aria-label="Toggle panel collapsed"
            onClick={onTogglePanelCollapsed}
          >
            <MenuExpandIcon />
          </button>
        )
      }
      <span className="team-timecard-toolbar-user">
        Team Cards
      </span>
    </div>
  );
}

TeamTimeCardToolbar.propTypes = {
  panelCollapsed: PropTypes.func.isRequired,
  onTogglePanelCollapsed: PropTypes.func.isRequired,
};
